import { useRef, useEffect } from "react";

// Scroll-reveal using native IntersectionObserver + CSS animation (reliable).
export function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!("IntersectionObserver" in window)) { el.classList.add("in"); return; }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { el.classList.add("in"); io.unobserve(el); }
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.05 }
    );
    io.observe(el);
    // Fallback: if already in viewport at mount, reveal on next tick
    const t = setTimeout(() => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in");
    }, 100);
    return () => { io.disconnect(); clearTimeout(t); };
  }, []);
  return (
    <Tag ref={ref} className={`reveal ${className}`} style={{ animationDelay: `${delay}s` }}>
      {children}
    </Tag>
  );
}

// Masked line-by-line headline reveal (CSS animation on mount).
export function MaskedLines({ lines, className = "", delay = 0 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="js-mask">
          <span style={{ animationDelay: `${delay + i * 0.12}s` }}>{line}</span>
        </span>
      ))}
    </span>
  );
}
